import Icon from '../components/Icon.vue'

Icon.register({"money-bill":{"width":640,"height":512,"paths":[{"d":"M608 64H32C14.3 64 0 78.3 0 96V416C0 433.7 14.3 448 32 448H608C625.7 448 640 433.7 640 416V96C640 78.3 625.7 64 608 64zM48 400V336C83.3 336 112 364.6 112 400H48zM48 176V112H112C112 147.4 83.3 176 48 176zM320 352C275.8 352 240 309 240 256 240 203 275.8 160 320 160S400 203 400 256C400 309 364.2 352 320 352zM592 400H528C528 364.6 556.6 336 592 336V400zM592 176C556.6 176 528 147.4 528 112H592V176z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/money-bill.js
// module id = QyFi
// module chunks = 0